import {ReactElement, ReactNode} from "react";
import styled from "styled-components";

import {breakpoints, quicksandSemiBold} from "@/GlobalStyle";
import {Kpi as KpiType} from "@/ts/kpi";

import {Tooltips} from "../../Tooltips/Tooltips";

const KpiContent = styled.div<{$haveBorder: boolean}>`
  width: 80%;
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  flex-wrap: nowrap;
  border-bottom: ${({$haveBorder, theme}) =>
    $haveBorder ? `solid 3px  ${theme.colors.darkPrimary}` : ""};
  padding: 10px;
  gap: 10px;
  @media (max-width: ${breakpoints.md}) {
    width: calc(95% - 20px);
    gap: 5px;
  }
`;

const KpiLabel = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 1.25rem;
  @media (max-width: ${breakpoints.md}) {
    gap: 1rem;
  }
`;

const KpiText = styled.h3`
  margin: 0;
  ${quicksandSemiBold}
  font-size: 1rem;
  color: ${({theme}) => theme.colors.mediumPrimary};
  flex: 1;
  text-overflow: ellipsis;
  overflow: hidden;
  line-clamp: 1;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* ou 1, 3, etc. */
  -webkit-box-orient: vertical;
  @media (max-width: ${breakpoints.md}) {
    -webkit-line-clamp: 3;
  }
`;

export function KpiElementList({
  kpi,
  children,
  haveBorder = true,
}: {
  kpi: KpiType;
  haveBorder?: boolean;
  children?: ReactNode;
}): ReactElement {
  return (
    <KpiContent data-testid="KpiContent" $haveBorder={haveBorder}>
      <KpiLabel data-testid="KpiLabel">
        <KpiText data-testid="KpiText">{kpi.nom}</KpiText>
        {kpi?.description ? <Tooltips content={kpi.description} /> : null}
      </KpiLabel>

      {children}
    </KpiContent>
  );
}
